import {
  LayoutDashboard, BookOpen, Calendar, UserCog, MapPin, LogOut,
  Users, Building2, Receipt, FileText, FileBarChart, BarChart3,
  Mail, MessageSquare, Bell, Cloud, Sparkles, GraduationCap,
  LifeBuoy, Star, Settings, MessageCircle, Package,
} from 'lucide-react';
import type { ReactNode } from 'react';

export interface MenuItem {
  key: string;
  to: string;
  label: string;          // i18n key
  icon: ReactNode;
  matchPrefix?: string;   // für isActive auch wenn URL noch sub-paths hat
}

export interface MenuGroup {
  key: string;
  label: string;          // i18n key
  icon: ReactNode;
  defaultOpen?: boolean;
  items: MenuItem[];
}

export type MenuEntry = MenuItem | MenuGroup;

export function isGroup(entry: MenuEntry): entry is MenuGroup {
  return 'items' in entry;
}

/** Hauptmenü (analog includes/sidebar.php). */
export const MAIN_MENU: MenuEntry[] = [
  {
    key: 'dashboard',
    to: '/',
    label: 'nav.dashboard',
    icon: <LayoutDashboard size={18} aria-hidden />,
    matchPrefix: '/dashboard',
  },
  {
    key: 'kurse',
    label: 'nav.kurse',
    icon: <BookOpen size={18} aria-hidden />,
    items: [
      { key: 'kurse/uebersicht', to: '/kurse',            label: 'nav.kurse.uebersicht', icon: <BookOpen size={16} aria-hidden /> },
      { key: 'kurse/kalender',   to: '/kurse/kalender',   label: 'nav.kurse.kalender',   icon: <Calendar size={16} aria-hidden /> },
      { key: 'kurse/ausbilder',  to: '/kurse/ausbilder',  label: 'nav.kurse.ausbilder',  icon: <UserCog  size={16} aria-hidden /> },
      { key: 'kurse/orte',       to: '/kurse/orte',       label: 'nav.kurse.orte',       icon: <MapPin   size={16} aria-hidden /> },
      { key: 'kurse/checkouts',  to: '/kurse/checkouts',  label: 'nav.kurse.checkouts',  icon: <LogOut   size={16} aria-hidden /> },
    ],
  },
  {
    key: 'teilnehmer',
    to: '/teilnehmer',
    label: 'nav.teilnehmende',
    icon: <Users size={18} aria-hidden />,
    matchPrefix: '/teilnehmer',
  },
  {
    key: 'firmen',
    to: '/firmen',
    label: 'nav.firmen',
    icon: <Building2 size={18} aria-hidden />,
    matchPrefix: '/firmen',
  },
  {
    key: 'feedback_auswertung',
    to: '/feedback-auswertung',
    label: 'nav.feedback_auswertung',
    icon: <FileBarChart size={18} aria-hidden />,
  },
  {
    key: 'abrechnung',
    label: 'nav.abrechnung',
    icon: <Receipt size={18} aria-hidden />,
    items: [
      { key: 'abrechnung/rechnungen', to: '/abrechnung/rechnungen', label: 'nav.abrechnung.rechnungen', icon: <FileText size={16} aria-hidden /> },
      { key: 'abrechnung/positionen', to: '/abrechnung/positionen', label: 'nav.abrechnung.positionen', icon: <FileText size={16} aria-hidden /> },
      { key: 'abrechnung/export',     to: '/abrechnung/export',     label: 'nav.abrechnung.export',     icon: <FileText size={16} aria-hidden /> },
    ],
  },
  {
    key: 'personal',
    label: 'nav.personal',
    icon: <UserCog size={18} aria-hidden />,
    items: [
      { key: 'personal/uebersicht',    to: '/personal',                label: 'nav.personal.uebersicht',    icon: <Users size={16} aria-hidden /> },
      { key: 'personal/gruppen',       to: '/personal/gruppen',        label: 'nav.personal.gruppen',       icon: <Users size={16} aria-hidden /> },
      { key: 'personal/team',          to: '/personal/team',           label: 'nav.personal.team',          icon: <Users size={16} aria-hidden /> },
      { key: 'personal/verfuegbarkeit',to: '/personal/verfuegbarkeit', label: 'nav.personal.verfuegbarkeit',icon: <Calendar size={16} aria-hidden /> },
    ],
  },
  {
    key: 'statistik',
    label: 'nav.statistik',
    icon: <BarChart3 size={18} aria-hidden />,
    items: [
      { key: 'statistik/kurse',         to: '/statistik/kurse',         label: 'nav.statistik.kurse',         icon: <BarChart3 size={16} aria-hidden /> },
      { key: 'statistik/ausbilder',     to: '/statistik/ausbilder',     label: 'nav.statistik.ausbilder',     icon: <BarChart3 size={16} aria-hidden /> },
      { key: 'statistik/stunden',       to: '/statistik/stunden',       label: 'nav.statistik.stunden',       icon: <BarChart3 size={16} aria-hidden /> },
      { key: 'statistik/kostenstellen', to: '/statistik/kostenstellen', label: 'nav.statistik.kostenstellen', icon: <BarChart3 size={16} aria-hidden /> },
      { key: 'statistik/debitoren',     to: '/statistik/debitoren',     label: 'nav.statistik.debitoren',     icon: <BarChart3 size={16} aria-hidden /> },
    ],
  },
  {
    key: 'kommunikation',
    label: 'nav.kommunikation',
    icon: <Mail size={18} aria-hidden />,
    items: [
      { key: 'kommunikation/email',              to: '/kommunikation/email',              label: 'nav.kommunikation.email',              icon: <Mail size={16} aria-hidden /> },
      { key: 'kommunikation/sms',                to: '/kommunikation/sms',                label: 'nav.kommunikation.sms',                icon: <MessageSquare size={16} aria-hidden /> },
      { key: 'kommunikation/benachrichtigungen', to: '/kommunikation/benachrichtigungen', label: 'nav.kommunikation.benachrichtigungen', icon: <Bell size={16} aria-hidden /> },
    ],
  },
  { key: 'cloud',  to: '/cloud',  label: 'nav.cloud',  icon: <Cloud size={18} aria-hidden /> },
  { key: 'kissy',  to: '/kissy',  label: 'nav.kissy',  icon: <Sparkles size={18} aria-hidden /> },
  { key: 'academy',to: '/academy',label: 'nav.academy',icon: <GraduationCap size={18} aria-hidden /> },
  { key: 'ressourcen', to: '/ressourcen', label: 'nav.ressourcen', icon: <Package size={18} aria-hidden /> },
  { key: 'feedback_vorschlaege', to: '/feedback-vorschlaege', label: 'nav.feedback_vorschlaege', icon: <MessageCircle size={18} aria-hidden /> },
  { key: 'feedback_meldungen',   to: '/feedback-meldungen',   label: 'nav.feedback_meldungen',   icon: <MessageCircle size={18} aria-hidden /> },
  { key: 'support', to: '/support', label: 'nav.support', icon: <LifeBuoy size={18} aria-hidden /> },
];

/** Admin-Menü (nur für Admins sichtbar). */
export const ADMIN_MENU: MenuItem[] = [
  { key: 'admin/allgemein',          to: '/admin/allgemein',          label: 'nav.admin.allgemein',          icon: <Settings size={16} aria-hidden /> },
  { key: 'admin/benutzer',           to: '/admin/benutzer',           label: 'nav.admin.benutzer',           icon: <Users size={16} aria-hidden /> },
  { key: 'admin/bgqseh',             to: '/admin/bgqseh',             label: 'nav.admin.bgqseh',             icon: <Settings size={16} aria-hidden /> },
  { key: 'admin/briefoptionen',      to: '/admin/briefoptionen',      label: 'nav.admin.briefoptionen',      icon: <FileText size={16} aria-hidden /> },
  { key: 'admin/buchhaltung',        to: '/admin/buchhaltung',        label: 'nav.admin.buchhaltung',        icon: <Receipt size={16} aria-hidden /> },
  { key: 'admin/dsgvo-loeschung',    to: '/admin/dsgvo-loeschung',    label: 'nav.admin.dsgvo_loeschung',    icon: <Settings size={16} aria-hidden /> },
  { key: 'admin/emaileinstellungen', to: '/admin/emaileinstellungen', label: 'nav.admin.emaileinstellungen', icon: <Mail size={16} aria-hidden /> },
  { key: 'admin/erechnung',          to: '/admin/erechnung',          label: 'nav.admin.erechnung',          icon: <FileText size={16} aria-hidden /> },
  { key: 'admin/erinnerungen',       to: '/admin/erinnerungen',       label: 'nav.admin.erinnerungen',       icon: <Bell size={16} aria-hidden /> },
  { key: 'admin/erloeskonten',       to: '/admin/erloeskonten',       label: 'nav.admin.erloeskonten',       icon: <Receipt size={16} aria-hidden /> },
  { key: 'admin/firmenkategorien',   to: '/admin/firmenkategorien',   label: 'nav.admin.firmenkategorien',   icon: <Building2 size={16} aria-hidden /> },
  { key: 'admin/kostenstellen',      to: '/admin/kostenstellen',      label: 'nav.admin.kostenstellen',      icon: <Receipt size={16} aria-hidden /> },
  { key: 'admin/kursarten',          to: '/admin/kursarten',          label: 'nav.admin.kursarten',          icon: <BookOpen size={16} aria-hidden /> },
  { key: 'admin/onlineanmeldung',    to: '/admin/onlineanmeldung',    label: 'nav.admin.onlineanmeldung',    icon: <Settings size={16} aria-hidden /> },
  { key: 'admin/orte',               to: '/admin/orte',               label: 'nav.admin.orte',               icon: <MapPin size={16} aria-hidden /> },
  { key: 'admin/payment-devices',    to: '/admin/payment-devices',    label: 'nav.admin.payment_devices',    icon: <Settings size={16} aria-hidden /> },
  { key: 'admin/positionsvorlagen',  to: '/admin/positionsvorlagen',  label: 'nav.admin.positionsvorlagen',  icon: <FileText size={16} aria-hidden /> },
  { key: 'admin/qualifikationen',    to: '/admin/qualifikationen',    label: 'nav.admin.qualifikationen',    icon: <Star size={16} aria-hidden /> },
  { key: 'admin/smsversand',         to: '/admin/smsversand',         label: 'nav.admin.smsversand',         icon: <MessageSquare size={16} aria-hidden /> },
  { key: 'admin/sumup',              to: '/admin/sumup',              label: 'nav.admin.sumup',              icon: <Settings size={16} aria-hidden /> },
  { key: 'admin/textbausteine',      to: '/admin/textbausteine',      label: 'nav.admin.textbausteine',      icon: <FileText size={16} aria-hidden /> },
  { key: 'admin/willkommen',         to: '/admin/willkommen',         label: 'nav.admin.willkommen',         icon: <Settings size={16} aria-hidden /> },
  { key: 'admin/zahlungsarten',      to: '/admin/zahlungsarten',      label: 'nav.admin.zahlungsarten',      icon: <Receipt size={16} aria-hidden /> },
  { key: 'admin/autoabrechnung',     to: '/admin/autoabrechnung',     label: 'nav.admin.autoabrechnung',     icon: <Receipt size={16} aria-hidden /> },
  { key: 'admin/belegtransfer',      to: '/admin/belegtransfer',      label: 'nav.admin.belegtransfer',      icon: <FileText size={16} aria-hidden /> },
  { key: 'admin/oa-startseite',      to: '/admin/oa-startseite',      label: 'nav.admin.oa_startseite',      icon: <Settings size={16} aria-hidden /> },
  { key: 'admin/oa-erscheinungsbild',to: '/admin/oa-erscheinungsbild',label: 'nav.admin.oa_erscheinungsbild',icon: <Settings size={16} aria-hidden /> },
  { key: 'admin/oa-ansprechpartner', to: '/admin/oa-ansprechpartner', label: 'nav.admin.oa_ansprechpartner', icon: <Users size={16} aria-hidden /> },
  { key: 'admin/oa-seo',             to: '/admin/oa-seo',             label: 'nav.admin.oa_seo',             icon: <Settings size={16} aria-hidden /> },
  { key: 'admin/oa-rechtlich',       to: '/admin/oa-rechtlich',       label: 'nav.admin.oa_rechtlich',       icon: <FileText size={16} aria-hidden /> },
  { key: 'admin/oa-uebersicht',      to: '/admin/oa-uebersicht',      label: 'nav.admin.oa_uebersicht',      icon: <Settings size={16} aria-hidden /> },
];

/** Lookup: alle Items aus MAIN_MENU + ADMIN_MENU als flache Liste (für Favoriten-Rendering). */
export function flatMenu(): MenuItem[] {
  const flat: MenuItem[] = [];
  for (const e of MAIN_MENU) {
    if (isGroup(e)) flat.push(...e.items);
    else flat.push(e);
  }
  flat.push(...ADMIN_MENU);
  return flat;
}
